export default __webpack_public_path__ + "static/media/charthree.59e3140d.jpg";